import { safeDefine } from "../../registration/safe-define.js";
import { PosterElement } from "../../ui/poster/element.js";
//#region src/define/ui/poster.ts
safeDefine(PosterElement);
//#endregion

//# sourceMappingURL=poster.js.map